import React from 'react'
import AnsQandAUserAll from '../ansuser/AnsQandAUserAll';
import ManuOperation from './navOperationRoom/ManuOperation';
function AnsLaboratory() {
    return (
        <div className='global-page'>
            <ManuOperation menuActive={'ans'} />
            <AnsQandAUserAll roleUser={'Laboratory'}/>
        </div>
    )
}

export default AnsLaboratory